module.exports = __webpack_public_path__ + "img/frame (268).f31b46f6.jpg";